import React, { useState } from 'react';
import { InertiaLink } from '@inertiajs/inertia-react';
// import Logo from '@/Shared/Logo';
import { Nav } from 'react-bootstrap';
import { MainMenu } from '@/constants/Menus';

import { useProps } from '@/Shared/FuncComp';

export default ({prepend, append, ...props}) => {
	const menus = prepend||[];
	const {nav} = useProps();
	menus.splice(menus.length, 0, ...MainMenu);
	if (append) menus.splice(menus.length, 0, ...append);
	return <Nav {...props}>
		{menus.filter(menu=>!menu.hide).map(({route: menuRoute, name, ...menu}, idx)=>{
			return <Nav.Link as={InertiaLink} href={menuRoute?route(menuRoute):('#')} 
				key={menuRoute||("primary-menu-"+idx)} {...menu.props} active={nav===menuRoute}
			>{name}</Nav.Link>
		})}
		{/* <Nav.Link as={InertiaLink} href={route('inicio')}>Inicio</Nav.Link>
		<Nav.Link as={InertiaLink} href="/productos">Productos</Nav.Link> */}
		{/* <NavDropdown title="Menú" id="basic-nav-dropdown">
			<NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
			<NavDropdown.Item href="#action/3.2">Another action</NavDropdown.Item>
			<NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
			<NavDropdown.Divider />
			<NavDropdown.Item href="#action/3.4">Separated link</NavDropdown.Item>
		</NavDropdown> */}
	</Nav>
}
